import { DateTime } from 'luxon';

import { DateRanges } from 'app/components/DateRange';
import type { ComplianceDashboardTrendGranularity } from 'app/services/api/models/ComplianceDashboardTrends';

export function getLastNDaysRange(days: number): Date[] {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - (days - 1));
  return [start, end];
}

export function getLastNDaysDateRange(days: number): DateRanges {
  const [start, end] = getLastNDaysRange(days);
  return {
    fromDate: start.toISOString(),
    toDate: end.toISOString(),
  };
}

export function dateRangeToDates(dateRange: DateRanges): Date[] {
  return [
    DateTime.fromISO(dateRange.fromDate).toJSDate(),
    DateTime.fromISO(dateRange.toDate).toJSDate(),
  ];
}

export function getDefaultTrendGranularity(
  dates: Date[],
): ComplianceDashboardTrendGranularity {
  const from = DateTime.fromJSDate(dates[0]).startOf('day');
  const to = DateTime.fromJSDate(dates[1]).startOf('day');
  const days = to.diff(from, 'days').days + 1;
  const months = to.diff(from, 'months').months;

  if (days === 30) return 'weekly';
  if (months <= 1) return 'daily';
  if (months <= 2) return 'weekly';
  return 'monthly';
}
